// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__V8mBJ","colMin":"styles_colMin__1GAVd","colCheckbox":"styles_colCheckbox__3sVER"};